/* eslint-disable no-mixed-spaces-and-tabs */
function buildUrl(utils, params, roleName = '') {
    return Object.keys(params).includes('url')
        ? params.url
        : utils.buildUrl('apply', 'applications/applicant/edit', params) +
              `&role=${roleName}`;
}

export default {
    computed: {
        applyUrlTarget: {
            immediate: true,
            deep: true,
            get() {
                const params = this.$_.get(
                    this.currentStudent,
                    'applicant.meta.params',
                    {}
                );
                return this.$_.get(params, 'target', '_self');
            },
        },
        applyUrl: {
            immediate: true,
            deep: true,
            get() {
                const hasParams = this.$_.has(
                    this.currentStudent,
                    'applicant.meta.params'
                );
                const params = this.$_.get(
                    this.currentStudent,
                    'applicant.meta.params',
                    {}
                );

                const applyUrl = hasParams
                    ? buildUrl(this.$utils, params, this.authUser.role_name)
                    : '';
                return applyUrl;
            },
        },
    },
};
